import { HistoryService } from '@app-core/services';
import { ContractType } from '@app-model/api';
import { HistoryFilter } from '@app-model/history-filter';

import * as HistoryActions from './history.actions';

export interface State {
  contracts: ContractType[];
  contractFilters: HistoryFilter;
  gridContracts: ContractType[];
}

const InitialState: State = {
  contracts: [],
  contractFilters: new HistoryFilter(),
  gridContracts: [],
};

export function reducer(state = InitialState, action: HistoryActions.All): State {
  switch (action.type) {
    case HistoryActions.GET_CONTRACTS_SUCCESS: {
      return {
        ...state,
        contracts: action.payload.contracts.contracts,
        gridContracts: action.payload.contracts.contracts,
        contractFilters: action.payload.filters,
      };
    }

    case HistoryActions.FILTER_GRID: {
      const gridContracts = HistoryService.filter(action.payload, state.contracts);

      return { ...state, gridContracts };
    }

    case HistoryActions.UNDO_DECLINE_CONTRACT_SUCCESS: {
      return {
        ...state,
        contracts: action.payload.contracts,
        gridContracts: action.payload.contracts,
        contractFilters: action.payload.filters,
      };
    }

    default: {
      return state;
    }
  }
}
